import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Textarea, Textbox, ButtonRow } from 'components/generic';
import { getValueById } from 'utils';
import { contactUsInfoList } from 'config';
import Images from 'assets/Images';
import { cloneDeep } from 'lodash';
import './style.scss';

const ContactUs = props => {
	const [contactData, setContactData] = useState({});
	const referenceData = useSelector(state => state.referenceData)?.data;

	const contactInfo = useMemo(() => getValueById(referenceData, 'rd_companyContactDetails')?.value?.at(), [referenceData]);

	const dataHandler = (el, key) => {
		setContactData(prevState => {
			const data = cloneDeep(prevState);
			data[key] = el;
			return data;
		});
	};

	return (
		<div className='contact-us'>
			<div className='contact-us__info'>
				<span className='contact-us__title'>Contact Information</span>
				<ul className='contact-us__list'>
					{contactUsInfoList?.map((el, i) => (
						<li key={i} className='contact-us__item'>
							<span>
								<img src={Images[el?.image]} />
								{el?.name}
							</span>
							<p>{contactInfo[el?.key]}</p>
						</li>
					))}
				</ul>
			</div>
			<div className='contact-us__form'>
				<h2>Contact Us</h2>
				<Textbox label='Name' infoContent='Enter Name' placeholder='Enter' onChange={e => dataHandler(e?.target?.value, 'contact_name')} value={contactData?.contact_name} />
				<Textbox type='email' infoContent='Enter Email' label='Email' placeholder='Enter' onChange={e => dataHandler(e?.target?.value, 'contact_email')} value={contactData?.contact_email} />
				<Textbox type='number' infoContent='Enter Phone Number' label='Phone Number' placeholder='Enter' onChange={e => dataHandler(e?.target?.value, 'contact_phoneNo')} value={contactData?.contact_phoneNo} />
				<Textarea type='textarea' infoContent='Enter Message' label='Message' placeholder='Enter' onChange={e => dataHandler(e?.target?.value, 'contact_message')} value={contactData?.contact_message} />
				<ButtonRow label='None' label1='Submit' right handleButtonClick={() => props.onSave(contactData)} />
			</div>
		</div>
	);
};

export default ContactUs;
